module.exports = __webpack_public_path__ + "img/cards-kicker.6d1df70d.png";